<template>
  <s-section
    type="bordered"
    is-centered
    :title="logoCards.title"
  >
      <div class="row">
        <div class="col-xl-10 mx-auto">
          <logo-cards v-if="logoCards.items.length">
            <logo-cards-item
              v-for="item in logoCards.items"
              :key="item.id"
              :logo="item.logo"
              :title="item.title"
              :description="item.description"
            ></logo-cards-item>
          </logo-cards>
        </div>
      </div>
  </s-section>
</template>

<script>
import LogoCards from '~/components/common/logo-cards/LogoCards'
import LogoCardsItem from '~/components/common/logo-cards/LogoCardsItem'

export default {
  name: 'VmwareLogoCards',
  components: {
    LogoCards,
    LogoCardsItem
  },
  props: {
    logoCards: {
      type: Object,
      default: null
    }
  }
}
</script>